import React, { useEffect, useState } from 'react';
import { CompanyRow } from "../classes/CompanyRow.js"
import { useNavigate } from "react-router-dom";
import '../styles/ClientFinder.css';

var activeOverview = null;
var activeFilter = null;

function CommentsBox(row) {
    row = row["row"]
    return (
        <div class="row justify-content-center text-center ">
            <div class="col-7">
                <div class="input-group">
                    <span class="input-group-text">Comments</span>
                    <textarea id={row.stripedName + "Comments"} class="form-control" defaultValue={row.comments}></textarea>
                </div>
            </div>
        </div>
    )
}

function adjustArrows(down) {
    var clickedArrow = document.getElementById(down)

    var arrows = document.getElementsByClassName("arrow")

    for (var arrow of arrows) {
        if (arrow.classList.contains("up") && !arrow.classList.contains("sortIcon")) {
            arrow.classList.remove("up")
            arrow.classList.add("down")

            if (clickedArrow == arrow) {
                return
            }
        }
    }

    clickedArrow.classList.remove("down")
    clickedArrow.classList.add("up")
}

function resetOverviews() {
    var arrows = document.getElementsByClassName("arrow")

    for (var arrow of arrows) {
        if (arrow.classList.contains("up") && !arrow.classList.contains("sortIcon")) {
            arrow.classList.remove("up")
            arrow.classList.add("down")
        }
    }

    const overviews = document.getElementsByClassName("companyOverview")

    for (var overview of overviews) {
        overview.style.display = "none"
    }

    activeOverview = null
}

function adjustFilters(event, header, setter, currentData) {
    var newFilter = ""

    if (event.target.id.includes("select")) {
        const eventID = event.target.id
        const select = document.getElementById(eventID)
        newFilter = select.options[select.selectedIndex].text
    } else if (event.key == "Enter") {
        newFilter = document.getElementById(header + "Input").value
    } else {
        return
    }

    if (!currentData.filters) {
        currentData.filters = {}
    }

    const headerConv = {
        "Name": "primaryName",
        "Consultants": "totalConsultants",
        "IT Department": "itDepartmentSize",
        "Revenue": "rawRevenue",
        "Industry": "primaryIndustry",
        "Account Manager": "accountManager",
        "Assigned To": "formattedAssignedTo",
        "Assign Date": "formattedAssignDate",
        "Type" : "jackalType",
        "Status": "assignmentStatus",
    }

    activeFilter.style.display = "none"
    activeFilter = null

    if (newFilter == "") {
        delete currentData.filters[headerConv[header]]
    } else {
        currentData.filters[headerConv[header]] = newFilter
    }

    setter(Object.assign({}, currentData))
}

function setSort(header, direction, setter, currentData) {
    const headerConv = {
        "Name": "primaryName",
        "Consultants": "totalConsultants",
        "IT Department": "itDepartmentSize",
        "Revenue": "rawRevenue",
        "Industry": "primaryIndustry",
        "Account Manager": "accountManager",
        "Assigned To": "formattedAssignedTo",
        "Assign Date": "formattedAssignDate",
        "Type" : "jackalType",
        "Status": "assignmentStatus",
    }

    currentData.sortHeader = headerConv[header]
    currentData.sortDirection = direction

    if (activeFilter != null) {
        activeFilter.style.display = "none"
        activeFilter = null
    }

    setter(Object.assign({}, currentData))
}

function filterRows(rows, settings, filters, currentUser, requestManager) {
    var newRows = []
    const user = currentUser[0]
    const permissions = currentUser[1]

    const badTitles = ["consult", "contract", "consultative", "consultant", "consulting", "contracting", "contractor", "interim"]
    const blockList = settings.blockList.replaceAll(" ", "").split(",")

    const usernameConv = {
        "avisage": "Alyssa Visage",
        "emccleery": "Emily McCleery",
        "sclodfelter": "Steve Clodfelter",
        "dblackbourn": "Denise Blackbourn"
    }

    for (var i = 0; i < rows.length; i++) {
        var flag = true

        // if (rows[i].primaryName == "InComm") {
        //     console.log(rows[i], blockList.includes(rows[i].stripedName))
        // }

        if (blockList.includes(rows[i].stripedName) || rows[i].stripedName.length <= 2) {
            flag = false
        }

        if (permissions != "Admin" && (rows[i].assignedTo != user && rows[i].accountManager != usernameConv[user] && 
            !(rows[i].jackalType.includes("ICP") && (rows[i].assignedTo == user || rows[i].assignedTo=="Nobody")))) { 
            flag = false 
        }

        for (var badTitle of badTitles) {
            if (rows[i].stripedName.includes(badTitle)) {
                flag = false
                break
            }
        }

        if (rows[i].totalConsultants <= 0) {
            flag = false
        }


        if (rows[i].stripedName == "striveconsulting") {
            console.log(row)
        }

        rows[i].hiddenInTable = !flag
    }

    if (filters) {
        const filterSchema = {
            "primaryName": "Match",
            "totalConsultants": "Range",
            "itDepartmentSize": "Range",
            "rawRevenue": "Range",
            "primaryIndustry": "Match",
            "accountManager": "Match",
            "formattedAssignedTo": "Match",
            "formattedAssignDate": "Match",
            "jackalType": "Strict Match",
            "assignmentStatus": "Match",
        }

        for (var [header, filterType] of Object.entries(filterSchema)) {
            if (typeof filters[header] === "undefined") {
                continue;
            }

            if (header == "primaryName" && currentUser[1] != "Admin" && filters[header].length >= 5) {
                requestManager.request("usageReport", "POST", { lookup: filters[header], user: currentUser[0] }).then(res => res.json()).then((response) => {})
            }

            if (filterType.includes("Match")) {
                const goodValues = filters[header].replaceAll(", ", ",").split(",").map((value) => value.toLowerCase())
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i] == null) {
                        continue
                    }

                    var flag = true

                    for (var goodValue of goodValues) {
                        if (goodValue.charAt(0) === "!") {
                            var flag = false
                            goodValue = goodValue.slice(1)

                            if (goodValue.includes(rows[i][header].toLowerCase()) || rows[i][header].toLowerCase().includes(goodValue)) {
                                flag = true
                                break
                            }

                        } else {
                            if (filterType == "Match" && rows[i][header] != "" && (goodValue.includes(rows[i][header].toLowerCase()) || rows[i][header].toLowerCase().includes(goodValue))) {
                                flag = false
                            } else if (filterType == "Strict Match" && rows[i][header].toLowerCase() == goodValue.toLowerCase()) {
                                flag = false
                            }
                        }
                    }

                    if (header == "primaryName") {
                        if ((currentUser[1] == "Admin" ||
                            [currentUser[0], "Nobody", "N/A"].includes(rows[i].assignedTo) && goodValue.length >= 5 ||
                            currentUser[0] == rows[i].assignedTo) && !rows[i].hiddenInTable) {
                            rows[i].hiddenInTable = flag
                        } else {
                            rows[i].hiddenInTable = true
                        }
                    } else if (flag) {
                        rows[i] = null
                    }
                }
            } else {
                const [lowerBound, upperBound] = filters[header].replaceAll(" ", "").replaceAll(",", "").split("-").map((value) => parseInt(value))
                for (var i = 0; i < rows.length; i++) {
                    if (rows[i] == null) {
                        continue
                    }

                    if (rows[i][header] < lowerBound || rows[i][header] > upperBound || rows[i][header] == "Unknown") {
                        rows[i] = null
                    }
                }
            }
        }
    }

    newRows = []
    for (var row of rows) {
        if (row != null) {
            newRows.push(row)
        }
    }
    rows = newRows

    resetOverviews()

    return rows
}

function exportRows(rows) {
    const newRows = [["Primary Name", "Striped Name", "Aliases", "Total Consultants", "Bullhorn Consultants", "Dice Consultants", "SalesIntel Consultants", "IT Department Size", "Revenue", "Industry", "Account Manager", "Assigned To", "Assign Date", "Jackal Type", "Status"]]

    console.log(rows)
    for (var row of rows) {
        newRows.push([row.primaryName.replaceAll(",", ""), row.stripedName, String(row.aliases).replaceAll(",", "|"), row.totalConsultants, row.bullhornConsultants, row.diceConsultants, row.salesIntelConsultants, String(row.itDepartmentSize).replaceAll(",", ""), row.formattedRevenue, row.primaryIndustry, row.accountManager, row.assignedTo, row.formattedAssignDate, row.jackalType, row.assignmentStatus])
    }

    rows = newRows

    let csvContent = ''
    rows.forEach(row => {
        csvContent += row.join(',') + '\n'
    })

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8,' })
    const objUrl = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.style.display = "none"
    link.setAttribute('href', objUrl)

    link.setAttribute('download', 'JackalExport ' + new Date().toLocaleString() + '.csv')
    link.textContent = 'Click to Download'
    link.click()

    document.querySelector('body').append(link)
}

function sortRows(rows, sortHeader, sortDirection, currentUser) {
    if (typeof sortHeader === "undefined") {
        sortHeader = "totalConsultants"
    }

    if (typeof sortDirection === "undefined") {
        sortDirection = "down"
    }

    rows = rows.sort((row1, row2) => {
        var r1Val = (row1[sortHeader] === "Unknown") ? -1 : row1[sortHeader]
        var r2Val = (row2[sortHeader] === "Unknown") ? -1 : row2[sortHeader]

        if (currentUser[1] != "Admin") {
            if (row1.assignmentStatus == "Dead End") {
                r1Val -= 100000
            }

            if (row2.assignmentStatus == "Dead End") {
                r2Val -= 100000
            }
        }

        if (sortDirection == "down") {
            return (r2Val > r1Val) ? 1 : -1
        } else {
            return (r1Val < r2Val) ? -1 : 1
        }
    })

    if (activeFilter !== null) {
        activeFilter.style.display = "none"
        activeFilter = null
    }

    return rows
}

function removeHidden(rows) {
    var temp = []

    for (var row of rows) {
        if (!row.hiddenInTable) {
            temp.push(row)
        }
    }

    return temp
}

function condenseOnAliases(rows) {
    var seenAliases = {}
    for (var row of rows) {
        for (var alias of row.aliases) {
            if (alias == '' || alias == row.stripedName) { continue }
            seenAliases[alias] = row
        }
    }

    var newRows = []

    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];

        // if (row.stripedName.includes("sedg")) {
        //     console.log(seenAliases)
        //     console.log(row.stripedName, row.stripedName in seenAliases)
        // }

        if (row.stripedName in seenAliases) {
            seenAliases[row.stripedName].addRow(row)
            rows[i] = null
        } else {
            newRows.push(row)
        }
    }

    return newRows
}

function showOverview(company) {
    const overviewRow = document.getElementById(company.stripedName + "Overview")

    if (activeOverview !== null) {
        activeOverview.style.display = "none"

        if (activeOverview === overviewRow) {
            activeOverview = null
            return
        }
    }

    overviewRow.style.display = ""
    activeOverview = overviewRow
}

function setNewStatus(companyStriped, manager) {
    const selectBox = document.getElementById(companyStriped + "Select")
    const newStatus = selectBox.value

    manager.request("getClientFinderData", "POST", { "newStatus": [companyStriped, newStatus] }).then(res => res.json()).then((response) => {
        console.log("updated!")
    })
}

function saveInputs(row, manager, isAdmin) {
    if (isAdmin) {
        const selectBox = document.getElementById(row.stripedName + "AssignSelect")
        const newAssignTo = selectBox.value

        const assignedToCell = document.getElementById(row.stripedName + "AssignedTo")
        const statusCell = document.getElementById(row.stripedName + "AssignStatus")

        const commentsBox = document.getElementById(row.stripedName + "Comments")
        const comments = commentsBox.value

        const savingBox = document.getElementById(row.stripedName + "SavingBox")

        setTimeout(() => { savingBox.style.display = "" }, 300)

        if (row.assignedTo != newAssignTo) {
            var args = { "newAssign": [row.primaryName, row.stripedName, newAssignTo], "newComments": [row.stripedName, row.primaryName, comments] }
        } else {
            var args = { "newComments": [row.stripedName, row.primaryName, comments] }
        }

        manager.request("getClientFinderData", "POST", args).then(res => res.json()).then((response) => {
            console.log("updated!")
            savingBox.style.display = "none"

            assignedToCell.innerHTML = newAssignTo

            if (newAssignTo == "Nobody") {
                statusCell.innerHTML = "N/A"
            } else {
                statusCell.innerHTML = '<select id="' + row.stripedName + 'Select" class="form-select statusSelect" name="Dropbox"><option>Not Started</option><option>Investigating</option><option>Good Lead</option><option>Dead End</option></select>'
            }
        })
    } else {
        const commentsBox = document.getElementById(row.stripedName + "Comments")
        const comments = commentsBox.value

        const savingBox = document.getElementById(row.stripedName + "SavingBox")
        savingBox.style.display = ""

        manager.request("getClientFinderData", "POST", { "newComments": [row.stripedName, row.primaryName, comments] }).then(res => res.json()).then((response) => {
            console.log("updated!")
            savingBox.style.display = "none"
        })
    }
}

function showFilterBox(colID) {
    const colDiv = document.getElementById(colID)

    if (activeFilter) {
        activeFilter.style.display = "none";
    }

    if (activeFilter != colDiv) {
        colDiv.style.display = ""
        activeFilter = colDiv
    } else {
        activeFilter = null;
    }
}

function help() {
    const helpBlock = document.getElementById("HelpBlock")
    const helpButton = document.getElementById("HelpButton")

    if (helpBlock.style.display == "none") {
        helpBlock.style.display = "flex"
        helpButton.innerHTML = "Close"
    } else {
        helpBlock.style.display = "none"
        helpButton.innerHTML = "Help"
    }
}

function settings(nav) {
    nav("/settings")
}

function logout(setter) {
    document.cookie = "authKey=1; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    setter({})
}

function getAllowed(rows) {
    var allowed = {
        "Assigned To":[],
        "Account Manager":[],
        "Type":[],
        "Status":[]
    }

    var conv = {
        "Assigned To":"formattedAssignedTo",
        "Account Manager":"accountManager",
        "Type":"jackalType",
        "Status":"assignmentStatus",
    }

    for (var key of Object.keys(allowed)) {
        for (var row of rows) {
            var value = row[conv[key]]
            if (["", " ", "None"].includes(value)) {
                continue
            }

            if (!allowed[key].includes(value)) {
                allowed[key].push(value)
            }
        }

        allowed[key].sort()
        allowed[key] = ["", ...allowed[key]]
    }

    return allowed
}

function ClientFinder(args) {
    const currentAuthKey = document.cookie.split("; ").find((row) => row.startsWith("authKey="))?.split("=")[1]
    const navigate = useNavigate()
    const requestManager = args.requestManager

    useEffect(() => {
        if (typeof currentAuthKey === "undefined" || typeof data.keyExpired !== "undefined") {
            navigate("/login")
        }
    })

    const [data, setData] = useState({})

    var rows = []
    var allowed = []

    if (typeof data.status !== "undefined") {
        // console.log(data.comments)
        for (var row of data.rows) {
            var comp = new CompanyRow()
            comp.initalize(row, data.settings.startYear, data.comments)
            rows.push(comp)
            // console.log(row)
        }

        rows = condenseOnAliases(rows)
        rows = filterRows(rows, data.settings, data.filters, data.currentUser, requestManager)
        rows = sortRows(rows, data.sortHeader, data.sortDirection, data.currentUser)
        rows = removeHidden(rows)

        allowed = getAllowed(rows)
        // console.log(allowed)

    } else {
        requestManager.request("getClientFinderData", "POST", {}).then(res => res.json()).then((response) => {
            setData(response)
        })
    }

    // console.log("render...")

    return (
        <div class="" style={{"margin-left":"8%", "margin-right":"8%"}}>
            <div class="pt-5 pb-5 mb-5 text-center">
                {
                    (typeof data.status === "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (<div>
                            <div class="row justify-content-center text-center">
                                <button id="HelpButton" type="button" class="btn btn-secondary col-1" style={{ width: "10%" }} onClick={() => { help() }}>Help</button>
                                {
                                    (data.currentUser[1] === "Admin") ?
                                        (<>
                                            <button id="SettingsButton" type="button" class="btn btn-secondary col-1 ms-5" style={{ width: "10%", padding: "0px" }} onClick={() => { settings(navigate) }}>Settings</button>
                                            <button id="UsageReportButton" type="button" class="btn btn-secondary col-1 ms-5" style={{ width: "10%", padding: "0px" }} onClick={() => { navigate("/usageReport") }}>Usage Report</button>
                                        </>) :
                                        (<></>)
                                    // (<button id="SettingsButton" type="button" class="btn btn-secondary col-1 ms-5" style={{ width: "10%", padding: "0px" }} onClick={() => { settings(navigate) }}>Aliases</button>)
                                }
                                <button id="LogoutButton" type="button" class="btn btn-secondary col-1 ms-5" style={{ width: "10%", padding: "0px" }} onClick={() => { logout(setData) }}>Logout</button>
                            </div>
                            <div id="HelpBlock" class="row justify-content-center text-start pt-3" style={{ display: "none" }}>
                                <div class="col-10 pt-4">
                                    <p class="text-center">Welcome to Jackal 2.0! Along with a new look and increased performance, the site has some new features to be aware of:</p>
                                    <ol class="">
                                        <li class="pt-3">
                                            Filtering and sorting have been reworked to be similar to Bullhorn:
                                            <ul>
                                                <li>To filter or sort by a certain column, first click on that column header.</li>
                                                <li>To sort, click either the up or down arrow which will determine the direction of the sort (decreasing or increasing).</li>
                                                <li>
                                                    To filter, either enter a comma-seperated-list of the exact terms to match on (i.e. "Allstate, Visa, Medtronic" for Name)
                                                    or a range to match on (i.e. "25-300" for IT Department Size), and hit <kbd>Enter</kbd>. You can also choose to exclude certain
                                                    values by putting an '!' before the value to be excluded (i.e. "!Nobody" for Assigned To will only show companies that have been
                                                    assigned).
                                                </li>
                                                <li><u>Note:</u> to emulate the lookup feature of Jackal 1.0, simply use the name filter on this page.</li>
                                            </ul>
                                        </li>
                                        <li class="pt-3">
                                            You can now declare that multiple names refer to the same company with Aliases:
                                            <ul>
                                                <li>
                                                    When you go to the details page for a company there will be a box in its Quick Info section where you can
                                                    enter Aliases for said company.
                                                </li>
                                                <li>
                                                    Simply enter any alternative names that the company has, seperated by commas, and then hit save. If you want suggestions
                                                    you can click the 'Get Recommendations' button to see what aliases Daxtra's AI suggests.
                                                </li>
                                                <li>
                                                    This feature is intended to make it easier to match companies between Jackal and Bullhorn. For example,
                                                    if a company is named 'BNY Mellon' in Jackal but 'The Bank Of New York Mellon' in Bullhorn, you can enter that
                                                    as an alias to tell Jackal that they refer to the same company. Jackal will then show the proper Bullhorn information
                                                    for that company and will also add any new consultants that may have 'The Bank Of New York Mellon' on their resume
                                                    instead of 'BNY Mellon'.
                                                </li>
                                                <li>
                                                    <u>Note:</u> for security and data integrity purposes, aliases that cannot be verified automatically will have to
                                                    be manually approved by an Administrator.
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="pt-3">
                                            Quick overviews have been added to Client Finder:
                                            <ul>
                                                <li>
                                                    When you click on a company on this page you will now be provided with a quick overview of the data we have on them.
                                                </li>
                                                <li>To continue to the next page like in Jackal 1.0, simply click the link in the overview.</li>
                                                <li>
                                                    This overview also gives you the ability to add comments about a company, just make sure to hit save after
                                                    entering them in the comments box. Please
                                                </li>
                                            </ul>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            {
                                (typeof data.filters !== "undefined" && Object.keys(data.filters).length > 0 || typeof data.sortHeader !== "undefined") ?
                                    (<button id="ResetFilters" type="button" class="btn btn-outline-secondary col-1 py-1 mt-3" style={{ width: "8%", padding: "0px" }} onClick={() => { setData({}) }}>Reset Filters</button>) :
                                    (<></>)
                            }
                            <div class="col-12 mt-4" id="table-wrapper">
                                <table id="myTable" class="table table-bordered sortable border-2 border-dark text-center">
                                    <thead class="stickyHeader">
                                        <tr class="table-success border-2 border-dark border-top-0">
                                            {["Name", "Consultants", "IT Department", "Revenue", "Account Manager", "Assigned To", "Assign Date", "Type", "Status"].map((header) =>
                                                <th onClick={() => showFilterBox(header + "Filter")}>
                                                    <div class="dropdown">
                                                        {header}
                                                        {(!["Account Manager", "Assigned To", "Type", "Status"].includes(header)) ?
                                                            (<div class="dropdown-content" style={{ display: "none" }} id={header + "Filter"}>
                                                                <div class="my-2">
                                                                    <i class="arrow down mx-2 mb-2 sortIcon" id={header + "Down"} onClick={() => { setSort(header, "down", setData, data) }}></i>
                                                                    <i class="arrow up mx-2 mt-1 sortIcon" id={header + "Up"} onClick={() => { setSort(header, "up", setData, data) }}></i>
                                                                </div>
                                                                <input style={{ width: "250px" }} autocomplete="off" onKeyDown={(event) => adjustFilters(event, header, setData, data)} onClick={() => showFilterBox(header + "Filter")} class="form-text form-control bg-light" id={header + "Input"}>
                                                                </input>
                                                            </div>) :
                                                            (<div class="dropdown-content" style={{ display: "none" }} id={header + "Filter"}>
                                                                <div class="my-2 mx-2">
                                                                    <i class="arrow down mx-2 mb-2 sortIcon" id={header + "Down"} onClick={() => { setSort(header, "down", setData, data) }}></i>
                                                                    <i class="arrow up mx-2 mt-1 sortIcon" id={header + "Up"} onClick={() => { setSort(header, "up", setData, data) }}></i>
                                                                    <select class="form-select statusSelect" name="Dropbox" id={"select-"+header} onClick={() => showFilterBox(header + "Filter")} onChange={(event) => adjustFilters(event, header, setData, data)}>
                                                                        {allowed[header].map((value) =>
                                                                            (<option>{value}</option>)
                                                                        )}
                                                                    </select>
                                                                </div>
                                                            </div>)
                                                        }
                                                    </div>
                                                </th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.slice(0, 500).map((row) =>
                                            (row.hiddenInTable) ?
                                                (<></>) :
                                                (<>
                                                    <tr id={row.stripedName}>
                                                        {
                                                            (row.primaryName.length > 32) ?
                                                                <td class="nameCell" onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.primaryName}<i class="arrow down mx-2 mb-1" id={row.stripedName + "Arrow"}></i></td> :
                                                                <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.primaryName}<i class="arrow down mx-2 mb-1" id={row.stripedName + "Arrow"}></i></td>
                                                        }
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.totalConsultants}</td>
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.itDepartmentSize}</td>
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.formattedRevenue}</td>
                                                        {/* <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }} class="industry">{row.primaryIndustry}</td> */}
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.accountManager}</td>
                                                        <td id={row.stripedName + "AssignedTo"} onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.formattedAssignedTo}</td>
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.formattedAssignDate}</td>
                                                        <td onClick={() => { showOverview(row); adjustArrows(row.stripedName + "Arrow") }}>{row.jackalType}</td>
                                                        {
                                                            (row.assignedTo === "Nobody") ?
                                                                (<td id={row.stripedName + "AssignStatus"}>N/A</td>) :
                                                                (<td id={row.stripedName + "AssignStatus"}>
                                                                    {
                                                                        (row.assignedTo == data.currentUser[0]) ?
                                                                            (<select id={row.stripedName + "Select"} class="form-select statusSelect" name="Dropbox" onChange={() => setNewStatus(row.stripedName, requestManager)}>
                                                                                {["Not Started", "Investigating", "Good Lead", "Dead End"].map((value) =>
                                                                                    (row.assignmentStatus == value) ?
                                                                                        (<option selected>{value}</option>) :
                                                                                        (<option>{value}</option>)
                                                                                )}
                                                                            </select>) :
                                                                            (<select id={row.stripedName + "Select"} class="form-select statusSelect" name="Dropbox" disabled>
                                                                                {["Not Started", "Investigating", "Good Lead", "Dead End"].map((value) =>
                                                                                    (row.assignmentStatus == value) ?
                                                                                        (<option selected>{value}</option>) :
                                                                                        (<option>{value}</option>)
                                                                                )}
                                                                            </select>)
                                                                    }
                                                                </td>)
                                                        }
                                                    </tr>
                                                    <tr class="companyOverview" id={row.stripedName + "Overview"} style={{ display: "none" }}>
                                                        <td colspan="9">
                                                            <h1 class="text-decoration-underline"><a href={"/companyDetails/" + row.stripedName}>{row.primaryName}</a></h1>
                                                            {
                                                                (row.description === "Unknown") ?
                                                                    (<br></br>) :
                                                                    (<>
                                                                        <p class="px-5 text-start overviewDescription">
                                                                            <strong>Description: </strong>{row.description}
                                                                        </p>
                                                                        <p class="px-5 text-start overviewDescription">
                                                                            <strong>Industries: </strong>{row.industries}
                                                                        </p>
                                                                    </>)
                                                            }
                                                            <div class="row justify-content-center">
                                                                <table id="myTable" class="overviewConsTable table table-bordered border-2 border-dark text-center">
                                                                    <tbody>
                                                                        <tr class="table-success border-2 border-dark">
                                                                            <th rowspan="2" class="align-middle">Consultant Summary</th>
                                                                            <th>Total Consultants</th>
                                                                            <th>Bullhorn Consultants</th>
                                                                            <th>Dice Consultants</th>
                                                                            <th>SalesIntel Consultants</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{row.totalConsultants}</td>
                                                                            <td>{row.bullhornConsultants}</td>
                                                                            <td>{row.diceConsultants}</td>
                                                                            <td>{row.salesIntelConsultants}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="row justify-content-center">
                                                                <table id="myTable" class="overviewConsTable table table-bordered border-2 border-dark text-center">
                                                                    <tbody>
                                                                        <tr class="table-success border-2 border-dark">
                                                                            <th rowspan="2" class="align-middle">Bullhorn Summary</th>
                                                                            <th>Account Manager</th>
                                                                            <th>Contacts</th>
                                                                            <th>Status</th>
                                                                            <th>Locations</th>
                                                                            <th>Date Added</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>{row.accountManager}</td>
                                                                            <td>{row.contacts}</td>
                                                                            <td>{row.bullhornStatus}</td>
                                                                            <td>{row.locations}</td>
                                                                            <td>{row.bullhornDateAdded}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <CommentsBox key={Math.random()} row={row}></CommentsBox>
                                                            {
                                                                (data.currentUser[1] === "Admin") ?
                                                                    (<div class="row pt-3 justify-content-center text-center">
                                                                        <div class="input-group mb-1 justify-content-center text-center">
                                                                            <div class="input-group-prepend">
                                                                                <label class="input-group-text" for={row.stripedName + "AssignSelect"}>Assigned To</label>
                                                                            </div>
                                                                            <select class="custom-select col-4 text-center" id={row.stripedName + "AssignSelect"}>
                                                                                <option value="Nobody">Nobody</option>
                                                                                {["avisage", "dblackbourn", "emccleery", "sclodfelter", "jgardner", "avalentine", "hutter", "jmaring", "kjudd"].map((value) =>
                                                                                    (row.assignedTo == value) ?
                                                                                        (<option selected>{value}</option>) :
                                                                                        (<option>{value}</option>)
                                                                                )}
                                                                            </select>
                                                                        </div>
                                                                    </div>) :
                                                                    (<></>)
                                                            }
                                                            <button class="btn btn-outline-primary col-2 mt-2" type="button" onClick={() => saveInputs(row, requestManager, data.currentUser[1] == "Admin")}>Save</button>
                                                            <div class="justify-content-center py-1" style={{ display: "none" }} id={row.stripedName + "SavingBox"}>
                                                                <h1 class="text-success">Saved!</h1>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </>)
                                        )
                                        }
                                    </tbody>
                                    <tfoot></tfoot>
                                </table>
                            </div>
                        </div>
                        )
                }
                {
                    (typeof data.status != "undefined" && data.currentUser[1] === "Admin") ?
                        (
                            <button id="ExportButton" type="button" class="btn btn-primary col-1 mt-3" style={{ width: "10%", padding: "5px" }} onClick={() => { exportRows(rows) }}>Export</button>
                        ) :
                        (<></>)
                }
            </div>
        </div>
    );
}

export default ClientFinder